export const TermsConditionsDataVoice = [
    {
      listName: "Consent and Authorization",
      list: [
        { item: "By using the voice message feature to request the creation of posts on PAMO, you consent to the recording, storage, and processing of your voice input on the App. PAMO complies with applicable laws regarding voice data collection. Users in jurisdictions requiring explicit consent confirm their agreement by using the feature." },
        { item: "You explicitly and irrevocably consent to PAMO using your voice messages to create posts on your behalf, according to the terms outlined in this Terms of Use, and to the general terms and conditions of the App." },
        { item: "You authorize PAMO to create posts on your behalf based on the content of the voice messages you send. You acknowledge that these posts are created to facilitate offers from merchants and are binding on you." }
      ]
    },
    {
      listName: "Eligibility",
      list: [
        { item: "To use the Voice Feature, you must have an active account on the App to access the Voice Feature." },
        { item: "You are solely responsible for ensuring that your use of the Voice Feature complies with all applicable local, state, and federal laws." },
        { item: "You must use a compatible device with the necessary hardware and software capabilities to access the Voice Feature." },
        { item: "You must not be a person barred from using the App under applicable laws, including sanctions or regulatory restrictions." }
      ]
    },
    {
      listName: "Order Confirmation",
      list: [
        { item: "The Voice Feature converts your voice input into a post on the App to create an order. You are responsible for reviewing and confirming the post created for accuracy before the post is made." },
        { item: "You agree that PAMO shall not be liable for any failure to confirm a post made from the Voice Feature on the App." }
      ]
    },
    {
      listName: "Quality of Voice Messages",
      list: [
        { item: "You are responsible for the clarity and quality of the voice messages you send. PAMO will not be liable for any issues arising from unclear or poor-quality voice messages." }
      ]
    },
    {
      listName: "Discrepancies",
      list: [
        { item: "PAMO will notify you once a post has been created based on your voice message. You acknowledge and agree that you shall bear full responsibility for the accuracy and completeness of the information provided in your voice messages as well as the consequences of your voice messages." },
        { item: "Once you confirm a post made from the Voice Feature on the App, the post becomes binding on you." },
        { item: "PAMO shall not be responsible for any discrepancies between the offers made by sellers/merchants and your original intent. You bear the responsibility of ensuring the accuracy of the offers you accept." }
      ]
    },
    {
      listName: "User Conduct",
      list: [
        { item: "You agree to provide accurate and complete information in your voice inputs." },
        { item: "You agree to avoid using offensive, illegal, or inappropriate language while using the Voice Feature on the App." }
      ]
    },
    {
      listName: "Use of Data and Privacy",
      list: [
        { item: "The App collects and processes voice data to provide the Voice Feature. Voice recordings, if necessary, may be shared with third-party service providers to facilitate transactions." },
        { item: "All voice data shall be processed and managed in accordance with PAMO’s Privacy Policy." }
      ]
    },
    {
      listName: "Timing",
      list: [
        { item: "You acknowledge that PAMO will create posts within a reasonable time, and you fully accept the risk of a delay." },
        { item: "PAMO will not be liable for any delays in processing voice messages and in creating posts." }
      ]
    },
    {
      listName: "Technical Issues",
      list: [
        { item: "PAMO does not always guarantee the uninterrupted or error-free performance of the Voice Feature." },
        { item: "Transcription errors, delays, or service interruptions may occur, and you agree that PAMO shall not be liable for any technical issues that may affect the creation, accuracy, or timing of posts created through the Voice Feature." }
      ]
    },
    {
      listName: "Privacy and Data Protection",
      list: [
        { item: "PAMO will handle voice messages in accordance with applicable data protection laws, including but not limited to the Data Protection Act, 2012 (Act 843)." },
        { item: "Voice messages will be stored securely and used solely for the purpose of creating posts." }
      ]
    },
    {
      listName: "Intellectual Property",
      list: [
        { item: "The Voice Feature and all related technology are the exclusive property of the Platform." },
        { item: "You are granted a limited, non-transferable license to use the feature in accordance with these Terms." },
        { item: "You retain ownership of the content of your voice messages and any resulting posts. By using the voice message feature, you grant PAMO a non-exclusive, royalty-free license to use, reproduce, and display the content for the purpose of facilitating transactions on the App." }
      ]
    },
    {
      listName: "User Rights",
      list: [
        { item: "You have the right to access, correct, or delete your personal data, including voice messages." },
        { item: "Requests to exercise these rights can be submitted to PAMO." }
      ]
    },
    {
      listName: "Dispute Resolution",
      list: [
        { item: "In the event of a dispute related to posts created from voice messages, you agree to use the dispute resolution feature." },
        { item: "If a resolution cannot be reached, you agree to submit to binding arbitration in accordance with PAMO’s dispute resolution policy." }
      ]
    }
  ];
  